export default {
  DJToJS: {
    /**
     * @typedef {Object} UserDJ
     * @property {Number} id - ID de l'utilisateur connecté
     * @property {String} first_name - Prénom de l'utilisateur
     * @property {String} last_name - Nom de l'utilisateur
     * @property {String} full_name - Nom complet de l'utilisateur
     * @property {String} username - Pseudo de l'utilisateur
     * @property {Boolean} is_staff - Indique si l'utilisateur est gestionnaire ou simple utilisateur
     * @property {Boolean} is_superuser - Indique si l'utilisateur est un administrateur
     * @property {String} last_login - Date de la dernière connexion
     *
     * @param user {UserDJ}
     * @return {UserAir}
     */
    convertUser (user) {
      return {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        fullName: user.full_name,
        username: user.username,
        isStaff: user.is_staff,
        isAdmin: user.is_superuser,
        staffStatus: user.is_staff,
        lastLogin: user.last_login
      }
    }
  },
  JSToDJ: {}
}
